import { Editor, track } from '@tldraw/tldraw'
import { useToggleRemoveBackground } from 'components/Design/utils/useToggleRemoveBackground'
import { ImageShape } from 'components/VisualStudioPlayground/Shapes/ImageShape/Types'
import { ToolbarButton } from '../../components/ToolbarButton'
import { Image03 } from 'blaze-ui/icons/24'
import { Scissors4 } from 'blaze-ui/icons'

interface Props {
  editor: Editor
  selectedShape: ImageShape
}

export const BackgroundButton = track(({ editor, selectedShape }: Props) => {
  const { toggle, isDisabled } = useToggleRemoveBackground({ editor, shape: selectedShape })
  const backgroundRemoved = selectedShape.props.removeBackground
  const Icon = backgroundRemoved ? () => <Image03 size={16} /> : Scissors4

  if (isDisabled) {
    return null
  }

  return (
    <ToolbarButton frontIcon={Icon} onPress={toggle}>
      {backgroundRemoved ? 'Original' : 'Background'}
    </ToolbarButton>
  )
})
